
export const getTranslatedPages = (t: (arg0: string) => any) => [
    { label: t("home"), path: "#" },
    { label: t("products"), path: "products" },
    { label: t("pricing"), path: "pricing" },
    { label: t("api_connect"), path: "api" },
  ];